<template>
  <main class="main-page">
    <div class="icon-back" v-if="showBack" @click="handleBack"/>
    <section v-if="!isiPad" class="left-panel" :class="supportClick ? 'hidden-scroll-bar' : ''">
      <iframe
        id="mall-iframe"
        class="preview"
        :class="supportClick ? 'is-click' : ''"
        height="100%"
        width="100%"
        frameborder="0"
        :scrolling="supportClick ? 'auto' : 'no'"
        :src="contents.iframeURL"
      ></iframe>
    </section>
    <section class="right-panel white-font">
      <AvatarCom
        v-if="showUserInfo"
        ref="userInfo"
        class="avatar-component"
        v-bind="userInfo"
        @success="handleLoginSuccess"
      />

      <img class="logo" src="./assets/logo.svg" alt="logo" />
      <title class="title space-x-10">
        <img :src="contents.iconURL" alt="icon" />
        <div>{{ contents.title }}</div>
      </title>
      <div class="outside">
        <img src="./assets/scan.svg" alt="scan" />
        <qrcode-vue
          :value="qrcodeUrl"
          :size="300"
        ></qrcode-vue>
      </div>
      <div class="openClient">打开客户端扫一扫</div>
      <div class="subTitle">{{ contents.subTitle }}</div>
    </section>
  </main>
</template>

<script>
import { category } from "./const";
import queryString from "query-string";
import QrcodeVue from "qrcode.vue";
import { reportMsg, templateToString } from "./utils";
import { fetchUserInfo } from './api'
import AvatarCom from "./components/AvatarCom.vue";
import { inBiliApp, closeView} from './bridges';

export default {
  components: {
    QrcodeVue,
    AvatarCom,
  },
  data() {
    return {
      contents: {
        title: "",
        iconURL: "",
        subTitle: "",
        iframeURL: "http://www.bilibili.com/h5/mall/digital-card/home?navhide=1&hybrid_set_header=2&act_id=100&from=webpage&f_source=home&-Abrowser=live",
      },
      qrcodeUrl: '',
      isiPad: false,
      supportClick: false,
      userInfo: {

      },
      showUserInfo: false,

    };
  },
  created() {
    const ua = navigator.userAgent;
    const ipad = ua.match(/(iPad).*OS\s([\d_]+)/i);
    this.isiPad = ipad !== null;
    const params = queryString.parse(location.search);
    // 无id或者type直接跳转
    if (!params.type) {
      window.location.href = "https://www.bilibili.com/h5/mall/guide?navhide=1";
    }
    this.supportClick = ['dlc'].includes(params.type)
    // 来源参数 query string，没有的话为空。
    const sourceQueryString = queryString.stringify({
      f_source: params.f_source,
      from: params.from,
      from_id: params.from_id
    })

    this.contents = category[params.type]

    const block1 = templateToString(this.contents.iframeURLPrefix, params)
    const block2 = `${sourceQueryString ? (block1.includes('?') ? '&' : '?')  + sourceQueryString : ''}`

    this.contents.iframeURL = block1 + block2
    // 用于生成二维码的链接
    const fromQrSource = queryString.stringify({
      ...queryString.parse(sourceQueryString) ,
      f_source: 'plat',
      from: 'webpage',
      from_middle: 1
    })

    this.qrcodeUrl = block1 + `${fromQrSource ? (block1.includes('?') ? '&' : '?')  + fromQrSource : ''}`


    if (params.type === "suit") {
      reportMsg(
        {
          spm_id: "333.859",
          CBlock: "zhuangban",
          DBlock: "web-middle",
          type: "pv",
        },
        {
          msg: JSON.stringify({
            f_source: "plat",
            from: "webpage",
          }),
        }
      );
    } else {
      reportMsg(
        {
          spm_id: "333.1069",
          CBlock: "nft",
          DBlock: "web-middle",
          type: "pv",
        },
        {
          msg: JSON.stringify({
            page_type: params.type === "digital" ? "1" : "2",
            f_source: "plat",
            from: "webpage",
          }),
        }
      );
    }
    // TODO: 调整到通过iframe调用
    // this.handleUserInfo()
  },

  computed: {
    showBack() {
      // return true
      return inBiliApp && this.isiPad
    }
  },

  mounted() {
    // mall-iframe
    // const myIframe = document.getElementById('mall-iframe').contentWindow
    // myIframe.postMessage('', '*')
    window.addEventListener('message', res => {
      // console.log('res', res)
      const { event, payload } = res?.data
      console.log('payload', payload)
      switch (event) {
        case 'show-login':
          this.showUserInfo = true
          this.userInfo = payload
          break;
        case 'login': {
          console.log('去登录')
          this.handleLogin()
          break
        }
        case 'nav': {
          console.log('去跳转')
          window.open(payload?.link, '_blank')
          break
        }
        default: {
          console.log('没匹配上任何event')
        }
      }
    })
  },
  methods: {
    handleUserInfo() {
      fetchUserInfo().then((res) => {
        if (+res.code === 0) {
          // 已登录
          this.userInfo = res.data
          console.log('res'. res.data)
        }
      })
    },
    handleLogin() {
      if (typeof this.$refs['userInfo']?.handleLogIn === 'function') {
        this.$refs['userInfo'].handleLogIn()
      }
    },
    handleLoginSuccess() {
      window.location.reload()
    },

    handleBack() {
      history.go(-1)
      setTimeout(()=>{
        closeView()
      },200)
    }
  }
};
</script>

<style>

@media screen and (min-height: 900px) {
  .left-panel, .right-panel {
    height: calc(100vh - 86px);
  }
}

@media screen and (max-height: 900px)  {
  .left-panel, .right-panel {
    height: calc(100vh - 40px);
  }
}

.left-panel {
  width: 375px;
  position: relative;
  flex-shrink: 0;
}

.left-panel .preview {
  position: absolute;
  pointer-events: none;
  border-radius: 0.5rem;
  border-width: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
}

.left-panel .is-click {
  pointer-events: auto;
  z-index: 1;
}

.left-panel.hidden-scroll-bar {
  overflow: hidden;
  border-radius: 0.5rem;
}

.right-panel {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.avatar-component.avatar-component {
  position: absolute;
  top: 0px;
  right: 0px;
}

.avatar-component.avatar-component .log-in-btn {
  width: 48px;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
}

.outside {
  position: relative;
  height: 457px;
  width: 340px;
}
.outside * {
  position: absolute;
}
.outside div {
  left: 22px;
  top: 135px;
}
.openClient {
  font-size: 32px;
  font-weight: bold;
}
.subTitle {
  font-size: 24px;
  letter-spacing: 10px;
}
.white-font {
  color: white;
}
.title {
  /* margin: 30px; */
  display: flex;
  /* flex-shrink: 1; */
  /* flex-grow: 1; */
  font-weight: 600;
  font-size: 32px;
  width: fit-content;
}
.space-x-10 > * + * {
  margin-left: 10px;
}
.logo {
  display: block;
  margin-top: 12px;
}
.main-page {
  height: 100vh;
  min-width: min-content;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  overflow: auto;
  /* gap: 10px; */
}

body {
  font-family: Arial, Helvetica, sans-serif;
  background-image: url("./assets/background.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  margin: 0;
}

.icon-back {
  width: 32px;
  height: 32px;
  background: url('./assets/icon-back.png') no-repeat center / 100%;
  position: fixed;
  top: 16px;
  left: 16px;
}
</style>
